/**
 * タッチデバイスかどうかを判定するユーティリティ関数
 * @returns {boolean}
 */
export function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
